var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.952 125.851L491.923 193.52C489.768 223.921 512.364 249.965 542.193 253.692L610.076 260.58C665.798 266.606 679.366 341.934 628.357 367.026L567.689 396.624C540.575 409.921 528.834 442.178 541.057 469.794L568.507 531.465C591.738 582.69 532.639 632.458 486.08 601.256L429.651 562.898C404.692 545.793 370.355 552.006 352.465 576.68L312.82 631.75C279.257 677.449 207.661 651.39 211.326 594.809L216.355 527.14C218.51 496.739 195.914 470.695 166.086 466.968L98.2025 460.08C42.4805 454.054 28.9118 378.726 79.9208 353.634L140.589 324.036C167.704 310.739 179.444 278.482 167.221 250.866L139.772 189.195C116.54 137.97 175.64 88.202 222.198 119.404L278.627 157.762C303.587 174.867 337.923 168.654 355.814 143.98L395.458 88.9102C429.021 43.211 501.404 69.5561 496.952 125.851Z",
    fill: "#FAF7F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 700,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshape);
export default __webpack_public_path__ + "static/media/starshape.1f8c6daa623219b9556b8c12cd39b1bd.svg";
export { ForwardRef as ReactComponent };